// GA4 / GTM Analytics Helper
// Events: form_submit, catalog_download, phone_click, whatsapp_click

const GA_MEASUREMENT_ID = ''; // Set in admin or env

// Initialize GTM dataLayer
window.dataLayer = window.dataLayer || [];

function gtag() {
  window.dataLayer.push(arguments);
}

export const initGA = (measurementId) => {
  if (!measurementId) return;
  // Load GA4 script dynamically
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);
  gtag('js', new Date());
  gtag('config', measurementId);
};

export const trackEvent = (eventName, params = {}) => {
  try {
    // GA4
    if (typeof gtag === 'function') {
      gtag('event', eventName, params);
    }
    // GTM dataLayer
    window.dataLayer.push({ event: eventName, ...params });
    console.debug(`[Analytics] ${eventName}`, params);
  } catch (e) {
    console.debug('[Analytics] Event push failed:', e);
  }
};

// Pre-defined event helpers
export const trackFormSubmit = (formName, formData = {}) => {
  trackEvent('form_submit', {
    form_name: formName,
    form_type: formData.type || 'contact',
    form_page: formData.page || window.location.pathname
  });
};

export const trackCatalogDownload = (method = 'email') => {
  trackEvent('catalog_download', { method });
};

export const trackPhoneClick = (number, location = '') => {
  trackEvent('phone_click', { phone_number: number, location });
};

export const trackWhatsAppClick = (source = '') => {
  trackEvent('whatsapp_click', { source });
};

export const trackEmailClick = (source = '') => {
  trackEvent('email_click', { source });
};

export default { trackEvent, trackFormSubmit, trackCatalogDownload, trackPhoneClick, trackWhatsAppClick, trackEmailClick, initGA };
